import axios from 'axios'
import API from '@/services/API'
import Utils from '@/services/utils'
import {getUserLang, loadLanguage} from "./lang";
import graphAuth from '@/services/graphAuth'
import graph from '@/services/graph'
import { initializeFlags } from '@/services/featureFlag'


var sha1 = require('sha1');

export default{
    // authentication status
    authenticated: false,
    accessToken: null,
    key: null,
    refresh_token: null,
    refresh_token_pending: false,
    user: null,
    offers: [],
    providerId: null,
    hash: '',


    isLoggedIn() {
        return this.authenticated;
    },

    login(username, password, callbackSuccess, callbackError){
        window.loginError = "";


        axios.post(API.apiAuthBaseUrl + API.endpoints.oauth.login, {
            username: username,
            password: password,
            client_id: 10,
            client_secret: "ttvIGgK5EsAnSVIFXiIivQOGtaJUdvQg7wqNLW9c"
        })
            .then(response => {


                this.authenticated = true;
                this.accessToken = response.data.access_token;
                this.refresh_token = response.data.refresh_token;
                window.V.$localStorage.set('ACCESS_TOKEN', this.accessToken);
                window.V.$localStorage.set('REFRESH_TOKEN', this.refresh_token);


                axios.defaults.headers.Authorization = 'Bearer ' + this.accessToken;
                axios.defaults.baseURL = API.apiBaseURL;

                var axiosCustom = axios.create({
                    baseURL: '/json/'
                });
                axios.get(API.endpoints.user.connected)
                    .then(async (responseUser) => {
                        this.key = responseUser.data.key;
                        this.user = responseUser.data.user;
                        //window.V.acl = responseUser.data.acl;
                        this.offers = responseUser.data.acl.offers;
                        this.providerId = responseUser.data.remoteProviderId;
                        this.hash = sha1(responseUser.data.user.iduser);

                        const userLang = await getUserLang(responseUser.data.user.iduser);
                        if (window.V.$localStorage.get('change_language') !== 'defined') {
                            loadLanguage(navigator.language.substring(0, 2))
                        } else {
                            loadLanguage(userLang);
                        }

                        axios.get(API.endpoints.user.acl)
                            .then(responseACL => {
                                window.V.acl = Utils.getFlatACL(responseACL.data);

                                axios.get(API.endpoints.user.client)
                                    .then(responseClientinfos => {
                                        window.V.clientInfos = responseClientinfos.data
                                        callbackSuccess();
                                    })
                                    .catch(e => {
                                        window.V.loginMode = true;
                                        this.logout();
                                    })



                            })
                            .catch(e => {
                                window.V.loginMode = true;
                                this.logout();
                            })


                    })
                    .catch(e => {
                        console.error(e)
                        window.V.loginMode = true;
                        this.logout();

                    })

            })
            .catch(e => {
                console.error(e)
                if(e.response && 403 === e.response.status){
                    window.loginError = Utils.t('login.noPermission');
                } else {
                    window.loginError = Utils.t('login.errors.incorrect_credentials');
                }
                callbackError(e);
            })

    },

    async MicrosoftLogin(callbackSuccess,callbackError) {
        graphAuth.configure(process.env.MICROSOFT_CLIENT_ID, false)
        await graphAuth.login()
        window.Vfc.$refs.loading.show();
        let graphToken = await graphAuth.acquireToken()

        window.loginError = "";
        axios.defaults.baseURL = API.apiAuthBaseUrl;

        axios.post(API.endpoints.oauth.microsoft, {
            access_token: graphToken,
            client_id: 10,
            client_secret: "ttvIGgK5EsAnSVIFXiIivQOGtaJUdvQg7wqNLW9c"
        })
            .then(response => {

                this.authenticated = true;
                this.accessToken = response.data.access_token;
                window.V.$localStorage.set('ACCESS_TOKEN', this.accessToken);

                axios.defaults.headers.Authorization = 'Bearer ' + this.accessToken;
                axios.defaults.baseURL = API.apiBaseURL;

                axios.get(API.endpoints.user.connected)
                    .then(async (responseUser) => {
                        this.key = responseUser.data.key;
                        this.user = responseUser.data.user;
                        //window.V.acl = responseUser.data.acl;
                        this.offers = responseUser.data.acl.offers;
                        this.providerId = responseUser.data.remoteProviderId;
                        this.hash = sha1(responseUser.data.user.iduser);

                        const userLang = await getUserLang(responseUser.data.user.iduser);
                        if (window.V.$localStorage.get('change_language') !== 'defined') {
                            loadLanguage(navigator.language.substring(0, 2))
                        } else {
                            loadLanguage(userLang);
                        }

                        axios.get(API.endpoints.user.acl)
                            .then(responseACL => {
                                window.V.acl = Utils.getFlatACL(responseACL.data);

                                axios.get(API.endpoints.user.client)
                                    .then(responseClientinfos => {
                                        window.V.clientInfos = responseClientinfos.data
                                        // Initialize feature flags after successful authentication
                                        initializeFlags().then(() => {
                                            callbackSuccess();
                                        }).catch(error => {
                                            console.error('Failed to initialize feature flags:', error);
                                            callbackSuccess(); // Continue even if flags fail
                                        });
                                    })
                                    .catch(e => {
                                        window.V.loginMode = true;
                                        this.logout();
                                    })


                            })
                            .catch(e => {
                                window.V.loginMode = true;
                                this.logout();
                            })


                    })
                    .catch(e => {
                        console.error(e)
                        window.V.loginMode = true;
                        this.logout();
                    })
            })
            .catch(e => {
                console.error(e)
                if (e.response && 403 === e.response.status) {
                    window.loginError = Utils.t('login.noPermission');
                }
                callbackError(e);
            })

    },

    googleLogin(token, callbackSuccess, callbackError){
        window.loginError = "";

        axios.defaults.baseURL = API.apiAuthBaseUrl;

        axios.post(API.endpoints.oauth.google, {
            access_token: token,
            client_id: 10,
            client_secret: "ttvIGgK5EsAnSVIFXiIivQOGtaJUdvQg7wqNLW9c"
        })
            .then(response => {
                this.authenticated = true;
                this.accessToken = response.data.access_token;
                window.V.$localStorage.set('ACCESS_TOKEN', this.accessToken);

                axios.defaults.headers.Authorization = 'Bearer ' + this.accessToken;
                axios.defaults.baseURL = API.apiBaseURL;


                /*axios.get(API.endpoints.user.connected)
                 .then(responseUser => {
                 this.user = responseUser.data;*/

                //callbackSuccess();
                //})

                var axiosCustom = axios.create({
                    baseURL: '/json/'
                });
                axios.get(API.endpoints.user.connected)
                    .then(async (responseUser) => {
                        this.key = responseUser.data.key
                        this.user = responseUser.data.user;
                        //window.V.acl = responseUser.data.acl;
                        this.offers = responseUser.data.acl.offers;
                        this.providerId = responseUser.data.remoteProviderId;
                        this.hash = sha1(responseUser.data.user.iduser);

                        const userLang = await getUserLang(responseUser.data.user.iduser);
                        if (window.V.$localStorage.get('change_language') !== 'defined') {
                            loadLanguage(navigator.language.substring(0, 2))
                        } else {
                            loadLanguage(userLang);
                        }

                        axios.get(API.endpoints.user.acl)
                            .then(responseACL => {
                                window.V.acl = Utils.getFlatACL(responseACL.data);

                                axios.get(API.endpoints.user.client)
                                    .then(responseClientinfos => {
                                        window.V.clientInfos = responseClientinfos.data
                                        // Initialize feature flags after successful authentication
                                        initializeFlags().then(() => {
                                            callbackSuccess();
                                        }).catch(error => {
                                            console.error('Failed to initialize feature flags:', error);
                                            callbackSuccess(); // Continue even if flags fail
                                        });
                                    })
                                    .catch(e => {
                                        window.V.loginMode = true;
                                        this.logout();
                                    })
                            })
                            .catch(e => {
                                window.V.loginMode = true;
                                this.logout();
                            })


                    })
                    .catch(e => {
                        window.V.loginMode = true;
                        this.logout();

                    })

            })
            .catch(e => {
                console.error(e)
                if(e.response && 403 === e.response.status){
                    window.loginError = Utils.t('login.noPermission');
                }
                callbackError(e);
            })
    },

    checkToken(token, callbackSuccess, callbackError){

        window.loginError = "";

        axios.defaults.baseURL = API.apiBaseURL;

        var axiosCustom = axios.create({
            baseURL: '/json/'
        });

        axios.get(API.endpoints.user.connected, {
            headers: {'Authorization': 'Bearer ' + token},
        })
        //axios.get(API.endpoints.user.connected)
            .then(async (responseUser) => {

              axios.defaults.headers.Authorization = 'Bearer ' + token;

              this.key = responseUser.data.key
              this.authenticated = true;
              this.user = responseUser.data.user;
              //window.V.acl = responseUser.data.acl;
              this.offers = responseUser.data.acl.offers;
              this.providerId = responseUser.data.remoteProviderId;
              this.hash = sha1(responseUser.data.user.iduser);
              this.accessToken = token;
              window.V.$localStorage.set('ACCESS_TOKEN', this.accessToken);

            //   const userLang = await getUserLang(responseUser.data.user.iduser);
              const userLang = window.V.$localStorage.get('bpz_lang');
              if (window.V.$localStorage.get('change_language') !== 'defined') {
                loadLanguage(navigator.language.substring(0, 2))
              } else {
                loadLanguage(userLang);
              }

                axios.get(API.endpoints.user.acl)
                    .then(responseACL => {
                        window.V.acl = Utils.getFlatACL(responseACL.data);

                        axios.get(API.endpoints.user.client)
                            .then(responseClientinfos => {
                                window.V.clientInfos = responseClientinfos.data
                                // Initialize feature flags after successful authentication
                                initializeFlags().then(() => {
                                    callbackSuccess();
                                }).catch(error => {
                                    console.error('Failed to initialize feature flags:', error);
                                    callbackSuccess(); // Continue even if flags fail
                                });
                            })
                            .catch(e => {
                                window.V.loginMode = true;
                                this.logout();
                            })
                    })
                    .catch(e => {
                        window.V.loginMode = true;
                        this.logout();
                    })

            })
            .catch(e => {
                console.error(e)
                window.V.loginMode = true;
                this.logout();

            })
    },

    getRefreshToken( callbackSuccess, callbackError){
        if(!this.refresh_token_pending && !!window.V.$localStorage.get('REFRESH_TOKEN')) {
          this.refresh_token_pending = true;
            axios.post(API.apiAuthBaseUrl+API.endpoints.oauth.refresh, {
            refresh_token: window.V.$localStorage.get('REFRESH_TOKEN'),
            client_id: 10,
            client_secret: "ttvIGgK5EsAnSVIFXiIivQOGtaJUdvQg7wqNLW9c"
          })
            .then(responseToken => {
              this.accessToken = responseToken.data.access_token;
              this.refresh_token = responseToken.data.refresh_token;
              this.refresh_token_pending = false;
              window.V.$localStorage.set('ACCESS_TOKEN', this.accessToken);
              window.V.$localStorage.set('REFRESH_TOKEN', this.refresh_token);
              callbackSuccess(this.accessToken);
            })
            .catch(e => {
              this.authenticated = false;
              this.accessToken = null;
              this.refresh_token_pending = false;
              this.logout()
            })
        }
    },

    getHash(){
        return this.hash;
    },

    logout(){
        window.V.$localStorage.remove('ACCESS_TOKEN');
        window.V.$localStorage.remove('REFRESH_TOKEN');
        
        const baseUrl = Utils.getDevantBaseUrl();
        window.location.href = `${baseUrl}/logout`
    }
}
